import { Auth0Client } from '@auth0/auth0-spa-js';
import { Browser } from '@capacitor/browser';
import { isPlatform } from '@ionic/react';

export class OCAuth {
    private auth0Client: Auth0Client;

    constructor() {
        this.auth0Client = new Auth0Client({
            domain: 'auth.onlycat.com',
            clientId: 'rqwpeo4jPr7QmqR2M4hfvOsL7fRr8FTt',
            cacheLocation: 'localstorage'
        });
    }

    public isRedirectCallback(url: string): boolean {
        return url.includes('state') && (url.includes('code') || url.includes('error'));
    }

    public async login(options?: { screenHint?: 'signup' | 'login' }): Promise<void> {
        const isNative = isPlatform('hybrid');

        await this.auth0Client.loginWithRedirect({
            authorizationParams: {
                redirect_uri: isNative ? 'app.onlycat://onlycat.uk.auth0.com/capacitor/app.onlycat/callback'
                    : window.location.origin + '/account?path=' + window.location.pathname,
                screen_hint: options?.screenHint,
            },
            async openUrl(url: string) {
                console.log('openUrl', url);

                await Browser.open({
                    url,
                    windowName: "_self"
                });
            }
        });
    }

    public async isAuthenticated(): Promise<boolean> {
        return await this.auth0Client.isAuthenticated();
    }

    public async getUser(): Promise<any> {
        return await this.auth0Client.getUser();
    }

    public async completeRedirectCallback(url?: string): Promise<string> {
        console.log('completeRedirectCallback', url);

        await this.auth0Client.handleRedirectCallback(url);

        return await this.auth0Client.getTokenSilently();
    }
}

export default new OCAuth();
